<template>
  <div class="summary-section">
    <h2 class="summary-section__title">
      {{ title }}
    </h2>
    <ul class="summary-section__choices">
      <slot></slot>
    </ul>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<style lang="scss" scoped>
.summary-section {
  &__title {
    font-size: 18px;
    line-height: 26px;
    font-weight: 500;
    letter-spacing: -0.02em;
    text-align: center;
    margin-bottom: 8px;
  }

  &__choices {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    padding: 0;
  }
}
</style>
